import axios from "../../fetch-api/fetch-api";

export function updateLayoutApi(layout: string) {
  return axios.post("/update-products-listing-layout-v3", { layout });
}
